import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import { yccApiUrl } from '../../environments/environment'
import { ArgumentNullError } from "src/app/error/argument-null-error";



/**
 * Represents a utility service to handle Http requests and responses.
 * @export
 * @class HttpUtilityService
 */
@Injectable()
export class HttpUtilityService {

public  userId: string;
public  userName: string;
public httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

  /**
   * Creates an instance of HttpUtilityService.
   * @param {Http} _http
   *
   * @memberOf HttpUtilityService
   */
  constructor(private _http: HttpClient) {   
    
  }


  public post(url: string, request: any): Observable<any> {
    if (url === null || url === undefined) {
      throw new ArgumentNullError("url");
    }
    url = yccApiUrl + url;
      return this._http.post<any>(url , JSON.stringify(request), this.httpOptions).pipe(
      tap((result) => console.log(result)),
      catchError(this.handleError<any>('newRequest'))
    );
  }

public get(url: string,): Observable<any> {
  url = yccApiUrl + url;
  return this._http.get(url).pipe(
    map(this.extractData));
}

public externalpost(url: string, request: any): Observable<any> {
    if (url === null || url === undefined) {
      throw new ArgumentNullError("url");
    }
      return this._http.post<any>(url , JSON.stringify(request), this.httpOptions).pipe(
      tap((result) => console.log(result)),
      catchError(this.handleError<any>('newRequest'))
    );
  }

  private extractData(res: Response) {
    const body = res;
    return body || { };
  }
  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
